export default __webpack_public_path__ + "static/media/Australia_Awards.270ac352.jpg";